import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { Menu, MenuButton, MenuLink, MenuList } from "@reach/menu-button";
import ArrowUp from "../../../assets/images/arrow-up.svg";
import ArrowDown from "../../../assets/images/arrow-down.svg";
import { emitMenuOpen, useMenuAutoClose } from "./menuBus";

const StyledMenuList = styled(MenuList)`
  background-color: var(--sv-color-dark-green);
  margin-top: 5px;
  box-shadow: 8px 8px 8px 0px rgba(0, 0, 0, 0.15);
  &::after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 52px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--sv-color-dark-green) transparent;
  }
  &:focus {
    outline: none;
  }
  position: relative;
  z-index: 10;
  overflow: visible;
`;
const StyledMenuLink = styled(MenuLink)`
  font-family: var(--sv-font-sans);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 44px;
  text-decoration: none;
  display: block;
  padding-left: 20px;
  padding-right: 20px;
  color: var(--sv-color-white) !important;
  border-bottom: 1px solid var(--sv-color-dark-gray);
  &[data-reach-menu-item][data-selected] {
    font-weight: bold;
  }
  &:focus {
    outline: none;
  }
`;

const YourProductsMenu = ({
  orderFavoritesLink,
  orderHistoryLink,
  savedCartsLink,
  orderBandsLink,
  quickOrderLink,
  translationKey,
  currentFileRequired,
  activeClass,
  isSavedCarts,
  activeMenu,
}) => {
  const [clicked, setClicked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuId = "your-products-menu";

  useMenuAutoClose(menuId, isOpen, buttonRef);

  const availableItems = [
    "order-favorites-menu",
    "saved-carts",
    "order-bands",
    "my-orders-menu",
    "quick-order",
  ];

  const handleMenuUp = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuOut = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuClick = (e) => {
    if (clicked) {
      e.preventDefault();
      setClicked(false);
    }
  };

  const subItemsSelected = () => {
    return availableItems.findIndex((item) => item == activeMenu) !== -1;
  };
  return (
    <Menu
      onOpen={() => {
        setIsOpen(true);
        emitMenuOpen(menuId);
      }}
      onClose={() => setIsOpen(false)}
    >
      {({ isExpanded }) => (
        <React.Fragment>
          <MenuButton
            ref={buttonRef}
            className={`primary-nav-item ${
              subItemsSelected() ? "headerMenuActive" : ""
            }`}
          >
            {translationKey(currentFileRequired["YOUR_PRODUCTS"])}
            <img alt="" src={isExpanded ? ArrowUp : ArrowDown} />
          </MenuButton>
          <StyledMenuList>
            <StyledMenuLink
              href={orderFavoritesLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("order-favorites-menu")}
            >
              {translationKey(currentFileRequired["ORDER_FAVORITES"])}
            </StyledMenuLink>
            {isSavedCarts ? (
              <StyledMenuLink
                href={savedCartsLink}
                onClick={handleMenuClick}
                onMouseUp={handleMenuUp}
                onMouseOut={handleMenuOut}
                className={activeClass("saved-carts")}
              >
                {translationKey(currentFileRequired["SAVED_CARTS"])}
              </StyledMenuLink>
            ) : null}
            <StyledMenuLink
              href={orderBandsLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("order-bands")}
            >
              {translationKey(currentFileRequired["ORDER_BANDS"])}
            </StyledMenuLink>
            <StyledMenuLink
              href={orderHistoryLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("my-orders-menu")}
            >
              {translationKey(currentFileRequired["MY_ORDERS"])}
            </StyledMenuLink>
            <StyledMenuLink
              href={quickOrderLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("quick-order")}
            >
              {translationKey(currentFileRequired["QUICK_ORDER"])}
            </StyledMenuLink>
          </StyledMenuList>
        </React.Fragment>
      )}
    </Menu>
  );
};

YourProductsMenu.propTypes = {
  className: PropTypes.string,
};

export default YourProductsMenu;
